import { api } from './api';

export interface EmailSignature {
  id: string;
  name: string;
  body: string;
  isDefaultNew: boolean;
  isDefaultReply: boolean;
  isChambersBaseline: boolean;
  createdAt: string;
  updatedAt?: string;
}

export async function fetchSignatures(): Promise<EmailSignature[]> {
  const res = await api.get('/inbox/signatures');
  return res.data.signatures;
}

export async function createSignature(input: {
  name: string;
  body: string;
  isDefaultNew?: boolean;
  isDefaultReply?: boolean;
}): Promise<EmailSignature> {
  const res = await api.post('/inbox/signatures', input);
  return res.data;
}

export async function updateSignature(
  signatureId: string,
  input: Partial<{
    name: string;
    body: string;
    isDefaultNew: boolean;
    isDefaultReply: boolean;
  }>,
): Promise<EmailSignature> {
  const res = await api.patch(`/inbox/signatures/${signatureId}`, input);
  return res.data;
}

export async function deleteSignature(signatureId: string): Promise<void> {
  await api.delete(`/inbox/signatures/${signatureId}`);
}

export async function fetchDefaultSignatures(): Promise<{
  forNew: EmailSignature | null;
  forReply: EmailSignature | null;
}> {
  const res = await api.get('/inbox/signatures/defaults');
  return res.data;
}
